import { Injectable, inject } from '@angular/core';
import { PeriodService } from '@web/birdz-angular';
import { endOfYesterday, startOfYesterday } from 'date-fns';
import { FilterService } from './filter.service';

/**
 * Period shared by the KPI details and map tabs, so that changing the date in one tab changes it in the other
 */
@Injectable({ providedIn: 'root' })
export class KpiPeriodService extends PeriodService {
  private filterService = inject(FilterService);
  private defaultViewFilter: string | null = null;

  constructor() {
    super();
    const yesterday = startOfYesterday();
    this.initState({
      period: { from: yesterday, to: yesterday },
      min: new Date(2020, 0, 1, 0, 0, 0),
      max: yesterday,
      snapTo: 'day',
    });
  }

  /**
   * Sets default view (yesterday) once per filter:
   * the tab opened after the other one keeps the shared period instead of resetting it
   */
  setDefaultView(): void {
    const filter = JSON.stringify(this.filterService.getFilter());
    if (filter === this.defaultViewFilter) {
      return;
    }
    this.defaultViewFilter = filter;
    this.updateState({
      snapTo: 'day',
      period: {
        from: startOfYesterday(),
        to: endOfYesterday(),
      },
    });
  }
}
